import b from 'b_';
import { useIntl } from 'platform-components';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

import ChangesNotification from 'common.components/changes-notification/changes-notification';
import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';

export const SpecCourseHeader = () => {
    const intl = useIntl();
    const { classId } = useParams<{ classId: string }>();

    return (
        <div className={b('spec-course', 'header', { empty: !classId })}>
            <Helmet title={intl.formatMessage({ id: 'specCoursePage.title' })} />
            <TeacherHeader className="spec-course__nav" />
            <ChangesNotification />
        </div>
    );
};
